import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const ProductFamilySchema_ = z.object({
  id: productFamilyIdFormat.schema,
  title: z.string(),
  image: z.object({ url: z.string(), altText: z.string() }).nullish(),
  quantity: z.bigint(),
  committed: z.bigint(),
  reserved: z.bigint(),
  available: z.bigint(),

  products: z.array(
    z.object({
      id: productIdFormat.schema,
      title: z.string(),
      sku: z.string(),
      vendor: z.string(),
      image: z.object({ url: z.string(), altText: z.string() }).nullish(),
      quantity: z.bigint(),
      committed: z.bigint(),
      reserved: z.bigint(),
      available: z.bigint(),
    }),
  ),
});

export const ProductFamilySchema: z.ZodType<ProductFamily> =
  ProductFamilySchema_;
export interface ProductFamily extends z.infer<typeof ProductFamilySchema_> {}

export const getProductFamilies = {
  name: "getProductFamilies" as const,
  input: z.object({
    pageSize: z.number().min(1).max(100).optional().default(20),
    page: z.number().min(0).optional().default(0),
    search: z.string().optional(),
  }),
  output: z.object({
    productFamilies: z.array(ProductFamilySchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
};
